import Helper from './Helper';
import Swiper from 'swiper/bundle';

class MobileSliderHandler {
  constructor(config = {}) {
    const {
      outerWrapperSelector,
      sliderContainerSelector,
      sliderPaginationselector,
      sliderPrevSelector,
      sliderNextSelector,
      sliderBreakpoint
    } = config;

    this.outerWrapperSelector = outerWrapperSelector;
    this.sliderContainerSelector = sliderContainerSelector || '.swiper-container';
    this.sliderPaginationselector = sliderPaginationselector || '.swiper-pagination';
    this.sliderPrevSelector = sliderPrevSelector || '.swiper-button-prev';
    this.sliderNextSelector = sliderNextSelector || '.swiper-button-next';
    this.sliderBreakpoint = sliderBreakpoint || 768;

    this.sliders = document.querySelectorAll(this.outerWrapperSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);

    this.currentScreenWidth = window.innerWidth;
    this.sliderIsInitiated = false;
    this.swiperInstances = [];

    if (this.sliders) {
      this.bindEvents();
    }
  }

  bindEvents() {
    if(this.currentScreenWidth < this.sliderBreakpoint){
      this.initSwipers();
    } else {
      this.destroySwipers();
    }

    window.addEventListener('resize', () => {
      const vw = window.innerWidth;
      if (vw < this.sliderBreakpoint) {
        this.initSwipers();
      } else {
        this.destroySwipers();
      }
    });
  }

  initSwipers(){
    if(!this.sliderIsInitiated){
      this.slidersArray.forEach((slider, index) => {
        const swiperContainer = slider.querySelector(this.sliderContainerSelector);
        const slides = slider.querySelectorAll('.swiper-wrapper > *');
        Array.prototype.slice.call(slides).forEach(slide => {
          Helper.addClass(slide, 'swiper-slide');
          Helper.addClass(slide, 'ns-mobile-slider__item');
        });
        const instance = new Swiper(swiperContainer, {
          loop: true,
          slidesPerView: 1,
          pagination: {
            el: this.sliderPaginationselector,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return '<span class="' + currentClass + '"></span>' +
                      ' <span class="fraction-line"></span> ' +
                      '<span class="' + totalClass + '"></span>';
            },
          },
          navigation: {
            nextEl: this.sliderNextSelector,
            prevEl: this.sliderPrevSelector,
          },
        });
        this.swiperInstances.push(instance);
      });
      this.sliderIsInitiated = true;
    } else {
      // console.log('sliders already inited');
    }
  }
  destroySwipers(){
    if(this.sliderIsInitiated){
      this.slidersArray.forEach((slider, index) => {
        const slides = slider.querySelectorAll('.swiper-wrapper > *');
        Array.prototype.slice.call(slides).forEach(slide => {
          Helper.removeClass(slide, 'swiper-slide');
          Helper.removeClass(slide, 'ns-mobile-slider__item');
        });
        Helper.addClass(slider, 'was-killed');
      });
      this.swiperInstances.forEach(instance => {
        instance.destroy(true, true);
      });
      this.sliderIsInitiated = false;
    } else {
      // console.log('no sliders active');
    }
  }
}

export default MobileSliderHandler;
